"use client";
import React from "react";
/* Context used to store data responsible for switching between modes of a theme */
export const ThemeContext = React.createContext({});
/* Context used to globally define mode, used only within the library */
export const GlobalColorModeContext = React.createContext({});
